const promotions = {
    //  ส่วนลดสินค้า ฿  เงื่อนไข (ไม่บังคับ)
    promotion001: {
        type: 'ITEM_DOLLAR_DISCOUNT',
        results: [
            {
                value: null,
                items: [], 
                quantityLimit: null
            },
        ],
        condition: {
            type: "NO_CONDITION",
        },
        details: {
            title: "promotion001",
            description: "Apply a fixed dollar discount to specific items. | ให้ส่วนลดเงินสดกับสินค้าที่กำหนด",
            remoteImagePath: "/img/promotion/promotion001.jpg"
        },
    },
    promotion002: {
        type: 'CATEGORY_DOLLAR_DISCOUNT',
        results: [
            {
                value: null,
                categories: [],
                quantityLimit: null
            },
        ],
        condition: {
            type: "NO_CONDITION",
        },
        details: {
            title: "promotion002",
            description: "Apply a fixed dollar discount to items within a specific category. | ให้ส่วนลดเงินสดกับสินค้าภายในหมวดหมู่ที่กำหนด",
            remoteImagePath: "/img/promotion/promotion002.jpg"
        },
    },
    promotion003: {
        type: 'RECEIPT_DOLLAR_DISCOUNT',
        results: [
            {
                value: null,
            },
        ],
        condition: {
            type: "PRICE_RECEIPT_EXCEED",
        },
        details: {
            title: "promotion003",
            description: "Apply a fixed dollar discount to the entire receipt. | ให้ส่วนลดเงินสดกับยอดรวมของใบเสร็จ",
            remoteImagePath: "/img/promotion/promotion003.jpg"
        },
    },
    promotion004: {
        type: 'ITEM_PERCENTAGE_DISCOUNT',
        results: [
            {
                value: null,
                items: [],
                quantityLimit: null,
                cap: null,
            },
        ],
        condition: {
            type: "NO_CONDITION",
        },
        details: {
            title: "promotion004",
            description: "Apply a percentage discount to specific items. | ให้ส่วนลดเปอร์เซ็นต์กับสินค้าที่กำหนด",
            remoteImagePath: "/img/promotion/promotion004.jpg"
        },
    },
    promotion005: {
        type: 'CATEGORY_PERCENTAGE_DISCOUNT',
        results: [
            {
                value: null,
                categories: [],
                quantityLimit: null,
                cap: null,
            },
        ],
        condition: {
            type: "NO_CONDITION",
        },
        details: {
            title: "promotion005",
            description: "Apply a percentage discount to items within a specific category. | ให้ส่วนลดเปอร์เซ็นต์กับสินค้าภายในหมวดหมู่ที่กำหนด",
            remoteImagePath: "/img/promotion/promotion005.jpg"
        },
    },
    promotion006: {
        type: 'RECEIPT_PERCENTAGE_DISCOUNT',
        results: [
            {
                value: null,
                cap: null,
            },
        ],
        condition: {
            type: "PRICE_RECEIPT_EXCEED",
        },
        details: {
            title: "promotion006",
            description: "Apply a percentage discount to the total receipt. | ให้ส่วนลดเปอร์เซ็นต์กับยอดรวมของใบเสร็จ",
            remoteImagePath: "/img/promotion/promotion006.jpg"
        },
    },
    // ฟรีสินค้า
    // promotion007: {
    //     type: 'FREE_ITEM',
    //     results: [
    //         {
    //             product: {},
    //             quantity: null,
    //         },
    //     ],
    //     condition: {
    //         type: "NO_CONDITION",
    //     },
    //     details: {
    //         title: "promotion007",
    //         description: "Provide a free item as part of the promotion. | มอบสินค้าฟรีเป็นส่วนหนึ่งของโปรโมชั่น",
    //         // remoteImagePath: ""
    //         remoteImagePath: "/img/promotion/promotion007.png"

    //     },
    // },
    // ราคาพิเศษเมื่อซื้อสินค้า x ชิ้น
    promotion008: {
        type: 'ITEM_FIXED_PRICE',
        results: [
            {
                value: null,
                items: [],
                quantityLimit: null,
            },
        ],
        condition: {
            type: "QUANTITY_ITEM_EXCEED",
            items: [],
            threshold: null
        },
        details: {
            title: "promotion008",
            description: "Set a fixed promotional price for specific items when a quantity threshold is met. | กำหนดราคาพิเศษสำหรับสินค้าที่กำหนดเมื่อถึงจำนวนที่กำหนด",
            // remoteImagePath: ""
            remoteImagePath: "/img/promotion/promotion008.png"

        },
    },

    // // ลดสินค้า ฿ เมื่อซื้อถึงจำนวนชิ้น
    // promotion009: {
    //     type: 'ITEM_DOLLAR_DISCOUNT',
    //     results: [
    //         {
    //             value: null,
    //             items: [],
    //             quantityLimit: null
    //         },
    //     ],
    //     condition: {
    //         type: "QUANTITY_ITEM_EXCEED",
    //         items: [],
    //         threshold: null
    //     },
    //     details: {
    //         title: "promotion009",
    //         description: "Apply a fixed dollar discount to specific items when a quantity threshold is met. | ให้ส่วนลดเงินสดกับสินค้าที่กำหนดเมื่อถึงจำนวนที่กำหนด",
    //         remoteImagePath: ""
    //     },
    // },
     // ลดสินค้า % เมื่อซื้อถึงจำนวนชิ้น
    // promotion010: {
    //     type: 'ITEM_PERCENTAGE_DISCOUNT',
    //     results: [
    //         {
    //             value: null,
    //             cap: null,
    //             items: [],
    //             quantityLimit: null
    //         },
    //     ],
    //     condition: {
    //         type: "QUANTITY_ITEM_EXCEED",
    //         items: [],
    //         threshold: null
    //     },
    //     details: {
    //         title: "promotion010",
    //         description: "Apply a percentage discount to specific items when a quantity threshold is met. | ให้ส่วนลดเปอร์เซ็นต์กับสินค้าที่กำหนดเมื่อถึงจำนวนที่กำหนด",
    //         remoteImagePath: ""
    //     },
    // },

    // ลดหมวดหมู่เดียวกัน - ราคาคงที่
    promotion011: {
        type: 'CATEGORY_FIXED_PRICE',
        results: [
            {
                value: null,
                categories: [],
                quantityLimit: null,
                cap: null,
            },
        ],
        condition: {
            type: "SAME_CATEGORY_BUNDLE",
            category: null,
            threshold: null
        },
        details: {
            title: "promotion011",
            description: "Set a fixed price for items in the same category when bought together. | กำหนดราคาคงที่สำหรับสินค้าหมวดหมู่เดียวกันเมื่อซื้อจับคู่กัน",
            remoteImagePath: "/img/promotion/promotion011.png"
        },
    },
    // หมวดหมู่เดียวกันลด %
    // promotion012: {
    //     type: 'CATEGORY_PERCENTAGE_DISCOUNT',
    //     results: [
    //         {
    //             value: null,
    //             categories: [],
    //             quantityLimit: null,
    //             cap: null,
    //         },
    //     ],
    //     condition: {
    //         type: "SAME_CATEGORY_BUNDLE",
    //         category: null,
    //         threshold: null
    //     },
    //     details: {
    //         title: "promotion012",
    //         description: "Apply a percentage discount when buying items from the same category. | ให้ส่วนลดเปอร์เซ็นต์เมื่อซื้อสินค้าจากหมวดหมู่เดียวกัน",
    //         remoteImagePath: ""
    //     },
    // },
    // หมวดหมู่เดียวกัน ลด บาท
    // promotion013: {
    //     type: 'CATEGORY_DOLLAR_DISCOUNT',
    //     results: [
    //         {
    //             value: null,
    //             categories: [],
    //             quantityLimit: null,
    //         },
    //     ],
    //     condition: {
    //         type: "SAME_CATEGORY_BUNDLE",
    //         category: null,
    //         threshold: null
    //     },
    //     details: {
    //         title: "promotion013",
    //         description: "Apply a fixed dollar discount when buying items from the same category. | ให้ส่วนลดเงินบาทเมื่อซื้อสินค้าจากหมวดหมู่เดียวกัน",
    //         remoteImagePath: ""
    //     },
    // },
    // หมวดหมู่เดียวกัน ฟรีสินค้า
    // promotion014: {
    //     type: 'FREE_ITEM',
    //     results: [
    //         {
    //             product: {},
    //             quantity: null,
    //         },
    //     ],
    //     condition: {
    //         type: "SAME_CATEGORY_BUNDLE",
    //         category: null,
    //         threshold: null
    //     },
    //     details: {
    //         title: "promotion014",
    //         description: "Get a free item when buying items from the same category. | รับสินค้าฟรีเมื่อซื้อสินค้าจากหมวดหมู่เดียวกัน",
    //         remoteImagePath: "/img/promotion/promotion014.jpg"
    //     },
    // },
    //// จับคู่หมวดหมู่ ราคาคงที่
    promotion015: {
        type: 'CATEGORY_FIXED_PRICE',
        results: [
            {
                value: null,
                categories: [],
                quantityLimit: null,
                cap: null,
            },
        ],
        condition: {
            type: "BUNDLE_CATEGORY",
            bundle: [{ category: {}, quantity: null }, { category: {}, quantity: null }]
        },
        details: {
            title: "promotion015",
            description: "Set a fixed bundle price when buying from different categories. | กำหนดราคาคงที่เมื่อซื้อจับคู่สินค้าจากต่างหมวดหมู่",
            remoteImagePath: "/img/promotion/promotion015.png"
        },
    },
    // // จับคู่หมวดหมู่ลด %
    // promotion016: {
    //     type: 'CATEGORY_PERCENTAGE_DISCOUNT',
    //     results: [
    //         {
    //             value: null,
    //             categories: [],
    //             quantityLimit: null,
    //             cap: null,
    //         },
    //     ],
    //     condition: {
    //         type: "BUNDLE_CATEGORY",
    //         bundle: [{ category: {}, quantity: null }, { category: {}, quantity: null }]
    //     },
    //     details: {
    //         title: "promotion016",
    //         description: "Apply a percentage discount when buying from different categories. | ให้ส่วนลดเปอร์เซ็นต์เมื่อซื้อจับคู่สินค้าจากต่างหมวดหมู่",
    //         remoteImagePath: ""
    //     },
    // },
    // // จับคู่หมวดหมู่ ลดบาท
    // promotion017: {
    //     type: 'CATEGORY_DOLLAR_DISCOUNT',
    //     results: [
    //         {
    //             value: null,
    //             categories: [],
    //             quantityLimit: null,
    //         },
    //     ],
    //     condition: {
    //         type: "BUNDLE_CATEGORY",
    //         bundle: [{ category: {}, quantity: null }, { category: {}, quantity: null }]
    //     },
    //     details: {
    //         title: "promotion017",
    //         description: "Apply a fixed dollar discount when buying from different categories. | ให้ส่วนลดเงินบาทเมื่อซื้อจับคู่สินค้าจากต่างหมวดหมู่",
    //         remoteImagePath: ""
    //     },
    // },
    // จับคู่หมวดหมู่ free item
    // promotion018: {
    //     type: 'FREE_ITEM',
    //     results: [
    //         {
    //             product: {},
    //             quantity: null,
    //         },
    //     ],
    //     condition: {
    //         type: "BUNDLE_CATEGORY",
    //         bundle: [{ category: {}, quantity: null }, { category: {}, quantity: null }]
    //     },
    //     details: {
    //         title: "promotion018",
    //         description: "Get a free item when buying from different categories. | รับสินค้าฟรีเมื่อซื้อจับคู่สินค้าจากต่างหมวดหมู่",
    //         remoteImagePath: "/img/promotion/promotion018.jpg"
    //     },
    // },
    // promotion019: {
    //     type: 'CATEGORY_FIXED_PRICE',
    //     results: [
    //         {
    //             value: 490,
    //             categories: [],
    //             quantityLimit: -1,
    //             cap: 9999999,
    //         },
    //     ],
    //     condition: {
    //         type: "SAME_CATEGORY_BUNDLE",
    //         category: null,
    //         threshold: 2
    //     },
    //     details: {
    //         title: "promotion019",
    //         description: "Best Combo จับคู่ราคาพิเศษ ซื้อสินค้าหมวดหมู่เดียวกัน 2 ชิ้น ราคาพิเศษ | Best Combo - Buy 2 items from the same category at a special price",
    //         remoteImagePath: ""
    //     },
    // },
    // promotion020: {
    //     type: 'CATEGORY_FIXED_PRICE',
    //     results: [
    //         {
    //             value: 649,
    //             categories: [],
    //             quantityLimit: -1,
    //             cap: 9999999,
    //         },
    //     ],
    //     condition: {
    //         type: "SAME_CATEGORY_BUNDLE",
    //         category: null,
    //         threshold: 2
    //     },
    //     details: {
    //         title: "promotion020",
    //         description: "Pop Pop Special Deal ซื้อ 2 กระปุก ราคาพิเศษ คละรสชาติได้ | Pop Pop Special Deal - Buy 2 at a special price, mix flavors allowed",
    //         remoteImagePath: ""
    //     },
    // },
    // promotion021: {
    //     type: 'CATEGORY_FIXED_PRICE',
    //     results: [
    //         {
    //             value: 549,
    //             categories: [],
    //             quantityLimit: -1,
    //             cap: 9999999,
    //         },
    //     ],
    //     condition: {
    //         type: "SAME_CATEGORY_BUNDLE",
    //         category: null,
    //         threshold: 2
    //     },
    //     details: {
    //         title: "promotion021",
    //         description: "Mousse Mousse Special Deal ซื้อ 2 ชิ้น ราคาพิเศษ คละรสชาติได้ | Mousse Mousse Special Deal - Buy 2 at a special price, mix flavors allowed",
    //         remoteImagePath: ""
    //     },
    // }
    //ซื้อ A+B รับ c ฟรี
    // promotion022: {
    //     type: 'FREE_ITEM',
    //     results: [
    //         {
    //             product: null,
    //             quantity: 1,
    //         },
    //     ],
    //     condition: {
    //         type: "BUNDLE_ITEM",
    //         bundle: [{ product: {}, quantity: 1 }, { product: {}, quantity: 1 }]
    //     },
    //     details: {
    //         title: "promotion022",
    //         description: "Buy bundled items and get a free item. | ซื้อสินค้าจับคู่กัน รับสินค้าฟรี",
    //         remoteImagePath: "/img/promotion/promotion022.jpg"
    //     },
    // },
    // // แถมฟรี เมื่อซื้อสินค้าครบจำนวน
    // promotion023: {
    //     type: 'FREE_ITEM',
    //     results: [
    //         {
    //             product: null,
    //             quantity: null,
    //         },
    //     ],
    //     condition: {
    //         type: "QUANTITY_ITEM_EXCEED",
    //         items: [],
    //         threshold: null
    //     },
    //     details: {
    //         title: "promotion023",
    //         description: "Provide a free item when purchasing specified items reaching a quantity threshold. | แถมสินค้าฟรีเมื่อซื้อสินค้าในรายการที่กำหนดรวมครบตามจำนวน",
    //         remoteImagePath: "/img/promotion/promotion023.png"
    //     },
    // },
    // // ซื้อ x ชิ้น แถมฟรีสินค้าอื่นฟรี
    // promotion024: {
    //     type: 'FREE_ITEM',
    //     results: [
    //         {
    //             product: null,
    //             quantity: null,
    //         },
    //     ],
    //     condition: {
    //         type: "ITEM_X_FREE_Y",
    //         items: [],
    //         inCartQuantity: null
    //     },
    //     details: {
    //         title: "promotion024",
    //         description: "Buy X pieces of a specified item and get another item for free. | ซื้อสินค้าที่กำหนดครบจำนวน X ชิ้น รับสินค้าอื่นฟรี",
    //         remoteImagePath: "/img/promotion/promotion024.png"
    //     },
    // },
};
export default promotions;
